import { useEffect, useState } from 'react';
import { api } from './api';

// Cache + in-flight promise so we only ever fire one request per page load
let _cache = null;
let _pending = null;

const fetchAll = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_pending) return _pending;
  _pending = api.get('/site-images')
    .then(r => { _cache = r.data || {}; return _cache; })
    .catch(() => { _cache = {}; return _cache; })
    .finally(() => { _pending = null; });
  return _pending;
};

/**
 * Returns the override URL for `key` if admin set one, else `fallback`.
 */
export function useSiteImage(key, fallback) {
  const [url, setUrl] = useState(_cache?.[key] || fallback);
  useEffect(() => {
    let alive = true;
    fetchAll().then(map => {
      if (alive && map[key]) setUrl(map[key]);
    });
    return () => { alive = false; };
  }, [key, fallback]);
  return url;
}
